import { NgModule } from '@angular/core';
import { I18nConfig, provideConfig } from '@spartacus/core';
import {
  userAccountTranslations,
  userAccountTranslationChunksConfig,
} from 'src/feature-libs/kn-br-user/kn-br-account/assets/translations/translations';
import { UserAccountRootModule } from 'src/feature-libs/kn-br-user/kn-br-account/root/account-root.module';
import { USER_ACCOUNT_FEATURE } from 'src/feature-libs/kn-br-user/kn-br-account/root/feature-name';
import { userProfileTranslationChunksConfig, userProfileTranslations } from 'src/feature-libs/kn-br-user/kn-br-profile/assets/translations/translations';
import { USER_PROFILE_FEATURE } from 'src/feature-libs/kn-br-user/kn-br-profile/root/feature-name';
import { UserProfileRootModule } from 'src/feature-libs/kn-br-user/kn-br-profile/root/profile-root.module';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () =>
            import('../../../../feature-libs/kn-br-user/kn-br-account/kn-br-account.module').then(
              (m) => m.KnBrUserAccountModule
            ),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () =>
            import('../../../../feature-libs/kn-br-user/kn-br-profile/kn-br-profile.module').then(
              (m) => m.KnBrUserProfileModule
            ),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userAccountTranslations,
        chunks: userAccountTranslationChunksConfig,
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userProfileTranslations,
        chunks: userProfileTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
  ],
})
export class UserFeatureModule {}
